/*eslint-disable*/
import {
  Card,
  CardContent,
  LinearProgress,
  TextField,
  Typography
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Send } from "@material-ui/icons";
import avatar from "assets/img/faces/avatar1.jpg";
import ChatCard from "components/ChatCard/ChatCard.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { ParseUriParams } from "helpers/UriReader";
import {
  GetUserId,
  GetUserKey,
  GetUserToken,
  Logout
} from "helpers/UserHelper";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { SetClientMessageRead } from "queries/messaging/mutations";
import { GetClientMessages } from "queries/messaging/queries.js";
import React from "react";
import { compose, graphql, Query } from "react-apollo";
import { Redirect } from "react-router";
import {
  listenToClientMessages,
  RemoveMessageListeners,
  sendClientMessage,
  subscribeToClientMessaging
} from "sockets/api";
import TodoDialog from "../Todos/components/TodoDialog.jsx";

var ps;

class ClientMessages extends React.Component {
  state = {
    initiated: false,
    clientId: null,
    clientName: null,
    messages: [],
    inputText: "",
    comboRoute: "",
    openTodoDialog: false,
    selectedTodo: null
  };

  handelCloseTodoDialog = () => {
    this.setState({ openTodoDialog: false, selectedTodo: null });
  };

  handelOpenTodoDialog = (message, clientId, clientName) => {
    var todo = {
      client_fullname: clientName,
      client_id: clientId,
      desc: message.message
    };
    this.setState({ selectedTodo: todo, openTodoDialog: true });
  };

  todoAdded = todo => {};

  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      if (this.refs.chat1) {
        ps = new PerfectScrollbar(this.refs.chat1, {
          wheelSpeed: 0.5,
          wheelPropagation: true,
          minScrollbarLength: 20
        });
        const container = this.refs.chat1;
        var scrollBottom = container.scrollTop + container.clientHeight;
        container.scrollTop = scrollBottom;
      }
    }

    //msg init
    var clientId = null;
    if (this.props.clientId && this.props.clientName) {
      clientId = this.props.clientId;
      this.setState({
        clientId: this.props.clientId,
        clientName: this.props.clientName
      });
    } else {
      const params = ParseUriParams(this.props.location.search);
      const { clientName } = params;
      clientId = params.clientId;
      this.setState({ clientId: clientId, clientName: clientName });
    }

    const comboRoute = `subscribe/client_messaging/${GetUserId()}+${clientId}`;
    this.setState({ comboRoute: comboRoute, clientId: clientId });
    subscribeToClientMessaging(GetUserId(), clientId, GetUserToken());
    listenToClientMessages(comboRoute, data => this.onNewMessage(data));
  }

  componentWillUnmount() {
    RemoveMessageListeners(this.state.comboRoute);
    if (navigator.platform.indexOf("Win") > -1) {
      if (ps) {
        ps.destroy();
      }
    }
  }

  componentDidUpdate(e) {
    if (navigator.platform.indexOf("Win") > -1) {
      if (this.refs.chat1) {
        const container = this.refs.chat1;
        var scrollBottom = container.scrollTop + container.clientHeight;
        container.scrollTop = scrollBottom;
      }
    }
  }

  updatePs = () => {
    if (ps) {
      ps.update();
      if (this.refs.chat1) {
        const container = this.refs.chat1;
        var scrollBottom = container.scrollTop + container.clientHeight;
        container.scrollTop = scrollBottom;
      }
    }
  };

  onInputChange = event => {
    this.setState({ inputText: event.target.value });
  };

  sendMessage = () => {
    sendClientMessage(this.state.inputText, GetUserId(), this.state.comboRoute);
    this.setState({ inputText: "" });
  };

  onNewMessage = data => {
    if (data.error) return;

    const messages = [...this.state.messages];
    messages.push(data);
    this.setState({ messages: messages });

    if (data.sender_id.toString() !== GetUserId()) {
      this.setMessageRead(data.messageId);
    }
  };

  setMessageRead = messageId => {
    this.props
      .SetClientMessageRead({
        variables: {
          input: {
            brokerId: GetUserId(),
            token: GetUserToken(),
            messageId: messageId
          }
        }
      })
      .then(resp => {
        console.log("message read");
      })
      .catch(error => {
        console.log("err", error);
      });
  };

  render() {
    const { clientId, clientName } = this.state;

    return (
      <Grid container>
        <GridItem xs={12} sm={12} md={12} style={{flexBasis: "100%", maxWidth: "100%", margin: 'auto' }}>
          <Card>
            <CardContent>
              {this.props.clientId && this.props.clientName ? null : (
                <div>
                  <Typography variant="headline" className="centerCell">
                    Client Messages
                  </Typography>

                  <div
                    style={{
                      borderBottom: "1px solid #cccccc69",
                      margin: "5px auto",
                      width: "25%"
                    }}
                  />
                  {clientName ? (
                    <Typography variant="subheading" className="centerCell">
                      {clientName}
                    </Typography>
                  ) : null}
                </div>
              )}
              <div
                style={{
                  position: "relative",
                  height: "30em",
                  overflowY: "hidden",
                  overflowX: "hidden",
                  border: "1px solid #ababab57",
                  margin: "5px 0px",
                  padding: "5px 0px"
                }}
                id={"chatBlock"}
                ref={"chat1"}
              >
                <Grid
                  container
                  style={{
                    display: "inline-grid"
                  }}
                >
                  <Query
                    query={GetClientMessages}
                    variables={{
                      brokerId: GetUserId(),
                      clientId: clientId,
                      token: GetUserToken()
                    }}
                    fetchPolicy="network-only"
                  >
                    {({ loading, error, data }) => {
                      if (loading)
                        return (
                          <div>
                            <LinearProgress />
                          </div>
                        );

                      if (
                        error &&
                        error.message &&
                        error.message === "GraphQL error: invalid token"
                      ) {
                        Logout();
                        return <Redirect to="/app/portal/login" />;
                      } else if (error) return `Error! ${error.message}`;

                      const { Client, Messages } = data.ClientMessages;

                      let avatarPath = avatar;
                      if (
                        Client.client_avatar !== null &&
                        Client.client_avatar !== ""
                      ) {
                        avatarPath = Client.client_avatar;
                      }

                      let brokerAvatarPath = avatar;
                      if (GetUserKey("avatar") !== "") {
                        brokerAvatarPath = GetUserKey("avatar");
                      }

                      if (!this.state.initiated) {
                        this.setState({ messages: Messages, initiated: true });
                      }
                      return (
                        <React.Fragment>
                          {this.state.messages.map((message, index) => {
                            let ownMessage =
                              message.sender_id.toString() === GetUserId();
                            return (
                              <div key={index}>
                                <ChatCard
                                  ownMessage={ownMessage ? true : false}
                                  avatarPath={
                                    ownMessage ? brokerAvatarPath : avatarPath
                                  }
                                  name={
                                    ownMessage
                                      ? GetUserKey("name") +
                                        " " +
                                        GetUserKey("surname")
                                      : Client.client_fullname
                                  }
                                  text={message.message}
                                  date={message.date_sent}
                                  updatePs={this.updatePs}
                                  addTodo={() =>
                                    this.handelOpenTodoDialog(
                                      message,
                                      clientId,
                                      clientName
                                    )
                                  }
                                />
                              </div>
                            );
                          })}
                          {this.state.messages.length < 1 ? (
                            <Typography
                              className="centerCell"
                              variant="caption"
                            >
                              No messages for this client yet
                            </Typography>
                          ) : null}
                        </React.Fragment>
                      );
                    }}
                  </Query>
                </Grid>
              </div>
              <Grid container>
                <GridItem xs={12} sm={12} md={12} style={{ display: "flex" }}>
                  <TextField
                    label="Type a message..."
                    multiline
                    rowsMax="4"
                    value={this.state.inputText}
                    onChange={this.onInputChange}
                    fullWidth
                  />
                  <button
                    onClick={() => this.sendMessage()}
                    style={{
                      backgroundColor: "#f3f3f3",
                      border: "1px solid #949494",
                      cursor: "pointer"
                    }}
                  >
                    <Send />
                  </button>
                </GridItem>
              </Grid>
            </CardContent>
          </Card>
        </GridItem>
        {this.state.openTodoDialog ? (
          <TodoDialog
            open={true}
            closeDialog={this.handelCloseTodoDialog}
            todoAdded={resp => this.todoAdded(resp)}
            todo={this.state.selectedTodo}
          />
        ) : null}
      </Grid>
    );
  }
}

ClientMessages = compose(
  graphql(SetClientMessageRead, { name: "SetClientMessageRead" })
)(ClientMessages);

export default ClientMessages;



// WEBPACK FOOTER //
// ./src/views/Messaging/ClientMessages.jsx